import { onReady } from '../lib/on-ready.js';

function initBanner() {
    const bannerComponent = document.querySelector('.banner-component');
    if (!bannerComponent) {
        return;
    }

    const bannerClasses = document.querySelectorAll('.banner-active');
    const bannerSession = sessionStorage.getItem('banner');

    if (bannerSession !== 'clicked') {
        bannerComponent.classList.remove('d-none');
    }
    if (bannerSession === 'clicked') {
        bannerClasses.forEach((element) => element.classList.remove('banner-active'));
    }

    const bannerCloser = document.querySelector('.close-banner');
    if (!bannerCloser) {
        return;
    }

    bannerCloser.addEventListener('click', () => {
        bannerComponent.classList.add('d-none');
        bannerClasses.forEach((element) => element.classList.remove('banner-active'));
        sessionStorage.setItem('banner', 'clicked');
    });
}

onReady(initBanner);
